import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("model_3d", {"":{"3D model":["3D модель"],"Select a 3D model":["Выберите 3D модель"],"3D model should be in FBX or GLB format.":["3D модель должна быть в формате FBX или GLB"]}})